import { OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
var CallTranscriptComponent = /** @class */ (function () {
    function CallTranscriptComponent(bsModalRef) {
        this.bsModalRef = bsModalRef;
        this.transcriptLines = [];
    }
    CallTranscriptComponent.prototype.ngOnInit = function () {
        if (!this.data)
            return;
        var rawLines = this.data.split('\n');
        for (var _i = 0, rawLines_1 = rawLines; _i < rawLines_1.length; _i++) {
            var line = rawLines_1[_i];
            line = line.trim();
            if (!line) {
                continue;
            }
            if (line.startsWith('User:')) {
                this.transcriptLines.push({
                    speaker: 'User',
                    text: line.substring(5).trim()
                });
            }
            else if (line.startsWith('Agent:')) {
                this.transcriptLines.push({
                    speaker: 'Agent',
                    text: line.substring(6).trim()
                });
            }
            else {
                this.transcriptLines.push({
                    speaker: '',
                    text: line
                });
            }
        }
    };
    CallTranscriptComponent.prototype.closePanel = function () {
        this.bsModalRef.hide();
        if (this.onClose) {
            this.onClose.next('close');
            this.onClose.complete();
        }
    };
    return CallTranscriptComponent;
}());
export { CallTranscriptComponent };
